
import { Component, Vue,Emit } from 'vue-property-decorator'
import Pagination from "@/components/Pagination/index.vue";
import { OrderRecordService, CommunicationRecordInput,CommunicationRecordDto } from '@/api/service-proxies'
import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'
import { __param } from "tslib";
import moment from 'moment';
import { warn } from 'vue-class-component/lib/util';
import { orderRecordService } from '@/api/payments/order-record';

@Component
export default class CommunicationDialog extends Vue {
  private dialogVisible: boolean = false
  communicationRecordInput= new CommunicationRecordInput()
  isSkipHolidays: boolean = false
  isExporting: boolean = false
  messageStr = ""
  communicationRecordDtos =  [];

  
  public open(id,tenantId) {
    this.communicationRecordInput.orderRecordId = id
    this.communicationRecordInput.tenantId = tenantId
    //置空
    this.communicationRecordDtos = []
    this.getAllRecord()
    this.dialogVisible = true
  }

  getAllRecord(){
    orderRecordService.getCommunicationRecord(
      this.communicationRecordInput.tenantId,
      this.communicationRecordInput.orderRecordId
    )
    .then((result)=>{
      this.communicationRecordDtos = result
      console.log(result,'参数')
    })
    .catch((error)=>{
      this.$message.error("获取列表失败")
    })
  }

  addMessage() {
    this.communicationRecordInput.message = this.messageStr;
    orderRecordService.cteateCommunicationRecord(this.communicationRecordInput)
    .then((result)=>{
      this.getAllRecord()
      this.$message.success("添加成功")
      this.messageStr='';
      this.onSuccess()
    })
    .catch((error)=>{
      this.$message.error("添加失败")
    })
  }
  close() {
    this.dialogVisible = false;
  }
  @Emit("success")
    private onSuccess() {}

}

